import React, { createContext, useContext, useReducer } from 'react';
import { pncpBiddingDetailReducer, initialState, IPncpBiddingDetailState, Action } from './pncp-bidding-detail-reducer';

const PncpBiddingDetailStateContext = createContext<IPncpBiddingDetailState | undefined>(undefined);
const PncpBiddingDetailDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const PncpBiddingDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(pncpBiddingDetailReducer, initialState);

    return (
        <PncpBiddingDetailStateContext.Provider value={state}>
            <PncpBiddingDetailDispatchContext.Provider value={dispatch}>
                {children}
            </PncpBiddingDetailDispatchContext.Provider>
        </PncpBiddingDetailStateContext.Provider>
    );
};

export const usePncpBiddingDetailState = (): IPncpBiddingDetailState => {
    const context = useContext(PncpBiddingDetailStateContext);
    if (!context) {
        throw new Error('usePncpBiddingDetailState must be used within PncpBiddingDetailProvider');
    }
    return context;
};

export const usePncpBiddingDetailDispatch = (): React.Dispatch<Action> => {
    const context = useContext(PncpBiddingDetailDispatchContext);
    if (!context) {
        throw new Error('usePncpBiddingDetailDispatch must be used within PncpBiddingDetailProvider');
    }
    return context;
};
